import axiosFetch from './config';

export const AcceptAgreement = async (data) => {
  ////console.log(data);
  let token = await localStorage.getItem('registerToken')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/agreements/acceptance',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};


export const getAcceptedAgreements = async () => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: `/agreements/acceptance`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const getAcceptedAgreement = async (id) => {
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: `/agreements/directoryfiles/${id}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}